import axios from 'axios';
import setAuthToken from '../utils/setAuthToken';
import jwt_decode from 'jwt-decode';

import { SET_CURRENT_USER, SET_FID } from './types';

import ApiUtils from '../helper/ApiUtils';

// Set logged in user
export const setCurrentUser = (decoded) => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded,
  };
};
export const set_fId = (fId) => {
  return {
    type: SET_FID,
    payload: fId,
  };
};

// Login - Get User Token
export const signUser = (sqlData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${ApiUtils.cors}${ApiUtils.url}SubEdit/MemberLogin`,
      sqlData
    ); 
     

    if (res.data === '') {
      return false;
    } else {
      // Save to localStorage
      const token = res.data;
      console.log(`signUser ${JSON.stringify(res.data)}`);
      // Set token to ls
      localStorage.setItem('jwtToken', token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);

      dispatch(setCurrentUser(decoded));
      // Set current user
      // console.log(`signUser ${JSON.stringify(decoded)}`)

      return true;
    }
  } catch (error) {
    // console.log(`signUser error ${error}`);
    // invalid token format
  }
};

// Log user out
export const logoutUser = () => (dispatch) => {
  // Remove token from localStorage
  localStorage.removeItem('jwtToken');
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js